module.exports = __webpack_public_path__ + "static/media/lakers_logo_featured.4acfc23b.jpg";